import { X } from 'lucide-react'
import './ImageModal.scss'
const ImageModal = ({ imageUrl, isOpen, onClose }) => {
  if (!isOpen || !imageUrl) return null

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div
        className='modal-content image-modal'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='image-modal-header'>
          <button onClick={onClose} className='btn secondary'>
            <X size={20} />
          </button>
        </div>
        <div className='image-modal-body image-modal-wrapping'>
          {imageUrl.map((data, index) => (
            <img src={data} alt='Imag agrandie' className='full-image' />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ImageModal
